"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlexLayoutWithFixedWidthSupport = void 0;
const utilities_1 = require("./utilities");
/** Enables a column layout which supports both flexible and fixed widths.
 * @description For each column, {width} is taken to mean the flex-grow proportion (default 1)
 * and {maxWidth}, if specified, indicates a fixed-width column of that width.
 * This is an alternative to useFlexLayout. It requires <div> elements, not <table>.
  */
function useFlexLayoutWithFixedWidthSupport(hooks) {
    hooks.getHeaderGroupProps.push(props => {
        return utilities_1.AddStyles(props, { display: "flex" });
    });
    hooks.getRowProps.push(props => {
        return utilities_1.AddStyles(props, { display: "flex" });
    });
    const addWidthStyles = (props, column) => {
        // react-table seems to assign crazy high numbers to maxWidth
        // which we have to ignore
        const actualMaxWidth = typeof column.maxWidth === "undefined"
            ? undefined
            : column.maxWidth < 10000
                ? column.maxWidth
                : undefined;
        const flexGrow = actualMaxWidth
            ? 0 // Max width column doesn't grow at all
            : typeof column.width === "number"
                ? column.width
                : typeof column.width === "string"
                    ? parseInt(column.width)
                    : 1;
        return utilities_1.AddStyles(props, {
            flex: `${flexGrow} 0 auto`,
            width: actualMaxWidth
                ? `${actualMaxWidth}px`
                : typeof column.width === "string"
                    ? column.width
                    : typeof column.width === "number"
                        ? `${column.width}px`
                        : undefined
        });
    };
    hooks.getHeaderProps.push((props, { column }) => {
        return addWidthStyles(props, column);
    });
    hooks.getCellProps.push((props, { cell: { column } }) => {
        return addWidthStyles(props, column);
    });
}
exports.useFlexLayoutWithFixedWidthSupport = useFlexLayoutWithFixedWidthSupport;
//# sourceMappingURL=flex-layout-fixed-width.js.map